
//Header with home navigation button included
import star from "../../../assets/UI/star.png";
import { Link } from 'react-router-dom';
import HomeIcon from "../../../assets/UI/HomeIcon.png"
import './Header_Nav.css';




export default function HeaderNav({GoBack_to}) {
  return (
    <div>
        <div className="HomeHeader-nv">
        
        
            {/* Logo */}
            <div className="Logo-nv">
                <img src={star} className="star-nv" alt="Logo Star" />
                <h1 className="LogoTxt1-nv">Hangeul</h1>
                <h1 className="LogoTxt2-nv">Hero</h1>
            </div >
            <p className="Slogan-nv">Learn Korean the fun way!</p>
        </div>
      
      {/* Pink Narrow Banner */}
      <div className="narrow-banner-nv">

        <div className="NarrowBannerElements-nv">
            <div className="HomeElements">
                <div>
                    <Link to="/" className="HomeLink-nv"><img src={HomeIcon} className="HomeIcon-nv" alt="Home Icon" /></Link>
                </div>
                
                <div>
                    <Link to="/" className="NavLink-nv"><p className="NarrowBannerHomeTxt-nv">HOME</p></Link>
                </div>
            </div>
            
            <div>
                <p className="NarrowBannerHomeTxt-nv">|</p>
            </div>

            <div>
                <Link to={GoBack_to} className="NavLink-nv"><p className="NarrowBannerHomeTxt-nv">GO BACK</p></Link>
            </div>

            <div>
                <p className="NarrowBannerHomeTxt-nv">||</p>
            </div>

             <div>
                <p className="NarrowBannerHomeTxt-nv">PHONETICS</p>
            </div>

             <div>
                <p className="NarrowBannerHomeTxt-nv">|</p>
            </div>

            <div>
                <p className="NarrowBannerHomeTxt-nv">FLASHCARDS</p>
            </div>
            
            <div>
                <p className="NarrowBannerHomeTxt-nv">|</p>
            </div>

            <div>
                <p className="NarrowBannerHomeTxt-nv">GAMES & ACTIVITIES</p>
            </div>

            <div>
                <p className="NarrowBannerHomeTxt-nv">|</p>
            </div>

            <div>
                <p className="NarrowBannerHomeTxt-nv">GRAMMAR</p>
            </div>
        
        </div>
    
    </div>

</div>
        
  )
}